export default {
    gas: {
        id: 'gas',
        color: 'blue',
        imgUrl: `${require(`../assets/images/homepage/service-gas.svg`)}`,
        title: 'North America Natural Gas',
        description: '',
        lists: [
            {
                title: 'US/CAN interstates',
                items: [
                    'Berkshire',
                    'Boardwalk',
                    'Dominion',
                    'Enbridge',
                    'KinderMorgan',
                    'Transcanada',
                    'Williams',
                    '170+ total',
                ],
                columns: 3,
            },
            {
                title: 'Data Series:',
                items: [
                    'Operationally Available Nominations over 5 cycles',
                    'Unsubscribed Capacity',
                    'No Notice Activity',
                    'Gas Quality',
                    'Weather by Meter',
                    'Static Data',
                ],
                columns: 2,
            },
        ],
        link: 'North American Natural Gas Dataset',
        page: {
            iconUrl: `${require('../assets/images/datasets/gas.svg')}`,
            title: 'North american natural gas ',
            description: '',
            listTitle: 'US/CAN interstates',
            list: [
                {
                    boldText: 'Berkshire',
                    text: 'Operationally Avaliable Nominations',
                },
                {
                    boldText: 'Boardwalk',
                    text: 'over 5 cycles',
                },
                {
                    boldText: 'Dominion',
                    text: 'Unsubscribed Capacity',
                },
                {
                    boldText: 'Enbridge',
                    text: 'no notice activity',
                },
                {
                    boldText: 'KinderMorgan',
                    text: 'gas quality',
                },
                {
                    boldText: 'Transcanada',
                    text: 'weather by meter',
                },
                {
                    boldText: 'Williams',
                    text: 'static data',
                },
            ],
            texts: [
                {
                    title: 'About Dataset',
                    inner:
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>' +
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>',
                },
            ],
        },
    },
    weather: {
        id: 'weather',
        color: 'green',
        imgUrl: `${require(`../assets/images/homepage/service-weather.svg`)}`,
        title: 'North America Weather',
        description: '',
        lists: [
            {
                title: 'US weather station data',
                items: ['Over 35,0000 Stations in the Lower 48'],
                columns: 1,
            },
            {
                title: 'Data Series:',
                items: [
                    'Temperature',
                    'Precipitation',
                    'Barometric Pressure',
                    'Wind Direction and Speed',
                    'Humidity',
                    'Cloud Layers',
                ],
                columns: 2,
            },
        ],
        link: 'North American Weather Dataset',
        page: {
            iconUrl: `${require('../assets/images/datasets/weather.svg')}`,
            title: 'North America Weather',
            description: '',
            listTitle: 'US/CAN interstates',
            list: [
                {
                    boldText: 'Berkshire',
                    text: 'Operationally Avaliable Nominations',
                },
                {
                    boldText: 'Boardwalk',
                    text: 'over 5 cycles',
                },
                {
                    boldText: 'Dominion',
                    text: 'Unsubscribed Capacity',
                },
                {
                    boldText: 'Enbridge',
                    text: 'no notice activity',
                },
                {
                    boldText: 'KinderMorgan',
                    text: 'gas quality',
                },
                {
                    boldText: 'Transcanada',
                    text: 'weather by meter',
                },
                {
                    boldText: 'Williams',
                    text: 'static data',
                },
            ],
            texts: [
                {
                    title: 'About Dataset',
                    inner:
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>' +
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>',
                },
            ],
        },
    },
    oil: {
        id: 'oil',
        color: 'red',
        imgUrl: `${require(`../assets/images/homepage/service-oil.svg`)}`,
        title: 'US Oil by State (Beta)',
        description: '',
        lists: [
            {
                title: 'US Oil by State (Beta)',
                items: [
                    'TX',
                    'ND',
                    'AK',
                    'NM',
                    'CO',
                    'PA',
                    'CA',
                    'WY',
                    'OK',
                    'LA',
                    'UT',
                ],
                columns: 3,
            },
            {
                title: 'Data Series:',
                items: ['Wells', 'Monthly Production'],
                columns: 1,
            },
        ],
        link: 'Oil Dataset',
        page: {
            iconUrl: `${require('../assets/images/datasets/oil.svg')}`,
            title: 'Oil',
            description: '',
            listTitle: 'US/CAN interstates',
            list: [
                {
                    boldText: 'Berkshire',
                    text: 'Operationally Avaliable Nominations',
                },
                {
                    boldText: 'Boardwalk',
                    text: 'over 5 cycles',
                },
                {
                    boldText: 'Dominion',
                    text: 'Unsubscribed Capacity',
                },
                {
                    boldText: 'Enbridge',
                    text: 'no notice activity',
                },
                {
                    boldText: 'KinderMorgan',
                    text: 'gas quality',
                },
                {
                    boldText: 'Transcanada',
                    text: 'weather by meter',
                },
                {
                    boldText: 'Williams',
                    text: 'static data',
                },
            ],
            texts: [
                {
                    title: 'About Dataset',
                    inner:
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>' +
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>',
                },
            ],
        },
    },
    electricity: {
        id: 'electricity',
        color: 'yellow',
        imgUrl: `${require(`../assets/images/homepage/service-electricity.svg`)}`,
        title: 'North America Electricity (Beta)',
        description: '',
        lists: [
            {
                title: 'US power',
                items: ['NYISO', 'ERCOT', 'CAISO', 'MISO', 'SPP'],
                columns: 2,
            },
            {
                title: 'CAN Power Coming Soon',
                items: ['IESO', 'AESO'],
                columns: 1,
            },
            {
                title: 'Data Series:',
                items: ['LMP', 'Outages', 'DA', 'static data'],
                columns: 2,
            },
        ],
        link: 'US Electricity Dataset',
        page: {
            iconUrl: `${require('../assets/images/datasets/electricity.svg')}`,
            title: 'North America Electricity (Beta)',
            description: '',
            listTitle: 'US/CAN interstates',
            list: [
                {
                    boldText: 'Berkshire',
                    text: 'Operationally Avaliable Nominations',
                },
                {
                    boldText: 'Boardwalk',
                    text: 'over 5 cycles',
                },
                {
                    boldText: 'Dominion',
                    text: 'Unsubscribed Capacity',
                },
                {
                    boldText: 'Enbridge',
                    text: 'no notice activity',
                },
                {
                    boldText: 'KinderMorgan',
                    text: 'gas quality',
                },
                {
                    boldText: 'Transcanada',
                    text: 'weather by meter',
                },
                {
                    boldText: 'Williams',
                    text: 'static data',
                },
            ],
            texts: [
                {
                    title: 'About Dataset',
                    inner:
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>' +
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>',
                },
            ],
        },
    },
    crypto: {
        id: 'crypto',
        color: 'purple',
        imgUrl: `${require(`../assets/images/homepage/service-crypto.svg`)}`,
        title: 'Cryptocurrencies (Beta)',
        description: 'Market Data, Trading Data',
        lists: [
            {
                title: 'Data Series:',
                items: [
                    'Bitcoin',
                    'Ethereum',
                    'Tether',
                    'XRP',
                    'Bitcoin Cash',
                    'Bitcoin SV',
                ],
                columns: 2,
            },
        ],
        link: 'Cryptocurrency Dataset',
        page: {
            iconUrl: `${require('../assets/images/datasets/crypto.svg')}`,
            title: 'Cryptocurrencies (Beta)',
            description: '',
            listTitle: 'US/CAN interstates',
            list: [
                {
                    boldText: 'Berkshire',
                    text: 'Operationally Avaliable Nominations',
                },
                {
                    boldText: 'Boardwalk',
                    text: 'over 5 cycles',
                },
                {
                    boldText: 'Dominion',
                    text: 'Unsubscribed Capacity',
                },
                {
                    boldText: 'Enbridge',
                    text: 'no notice activity',
                },
                {
                    boldText: 'KinderMorgan',
                    text: 'gas quality',
                },
                {
                    boldText: 'Transcanada',
                    text: 'weather by meter',
                },
                {
                    boldText: 'Williams',
                    text: 'static data',
                },
            ],
            texts: [
                {
                    title: 'About Dataset',
                    inner:
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>' +
                        '<p>This Website, www.cleandataset.com, (the "Website") is owned and operated by CleanDataSet, Inc. ("CDS", "us", "we" or "our"), a Delaware corporation. CDS respects the privacy of every individual who uses this Website and therefore, we only wish to process and use the data obtained through the Website for our own purposes. The privacy policy located on this Website ("Privacy Policy") outlines the information we will collect and how we will use that information.</p>',
                },
            ],
        },
    },
};
